// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage  }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({

    id: '',
    service: '',
    message: '',
    templateId: '',
    senderId: '',
    userId: '',
    apiKey: '',
    entityId: '',
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
    
  //*********************************** Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();
   useEffect(() => {
    
    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');
        
        try {
          const response = await apiClient.get(`/api/admin/sms_formate/${invoiceId}`, {
          
                  headers: {
                    'access_token': token,
                  },
          
                });
          
          if(response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || '',
            service: response.data.data.service || '',
            message: response.data.data.message || '',
            templateId: response.data.data.templateId || '',
            senderId: response.data.data.senderId || '',
            userId: response.data.data.userId || '',
            apiKey: response.data.data.apiKey || '',
            entityId: response.data.data.entityId || '',
          });
          }
            else{
              console.log(response.data.message)
            }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };
  
    fetchInvoiceData();
  }, [invoiceId, edit]);  


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');
  
    try {
      const response = await apiClient.put(`/api/admin/sms_formate/update`, formData, {
      
              headers: {
                'access_token': token,
              },      
            });
      if(response.data.Status === "SUCCESS") {
        
      }
        else{
          console.log(response.data.message)
        }  
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };
  
  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit SMS_Formate
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="service" className="label-custom">Service</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="message" className="label-custom">Message</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="templateId" className="label-custom">Template ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="templateId"
                      name="templateId"
                      value={formData.templateId}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="senderId" className="label-custom">Sender ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="senderId"
                      name="senderId"
                      value={formData.senderId}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="userId" className="label-custom">User ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="userId"
                      name="userId"
                      value={formData.userId}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="apiKey" className="label-custom">Api Key</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="apiKey"
                      name="apiKey"
                      value={formData.apiKey}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className="spacing" style={{width:'35.20vw'}}>
                    <label htmlFor="entityId" className="label-custom">Entity ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="entityId"
                      name="entityId"
                      value={formData.entityId}
                      onChange={handleChange}
                    />
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
